import { fetch } from './mockApiUtils';
import representasjoner from './data/representasjoner.json';
import driftsmeldingData from './data/driftsmeldingData.json';

import skattOgAvgiftMockApi from './skattOgAvgift/skattOgAvgiftMockApi';

export default {
  getRepresentations() {
    return fetch(representasjoner);
  },
  getDriftsmeldinger() {
    return fetch(driftsmeldingData);
  },

  ...skattOgAvgiftMockApi,
};
